import { colors } from '../../variables.style'

import { createUseStyles } from 'react-jss'

export const style = {
  headerWrapper: {
    lineHeight: '1.15'
  },
  header: {
    display: 'flex',
    color: 'white',
    backgroundColor: colors.brandDark
  },
  headerLeft: {
    padding: '18px 40px 14px'
  },
  headerRight: {
    flex: '1 1 auto',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  reportType: {
    color: colors.nyanza,
    textTransform: 'uppercase',
    marginBottom: '6px'
  },
  reportTitle: {
    fontFamily: "'Raleway', sans-serif",
    fontVariantNumeric: 'lining-nums',
    fontSize: '28px',
    fontWeight: 'normal',
    margin: 0,
    textTransform: 'uppercase',
    height: '32px',
    display: 'flex'
  },
  logoContainer: {
    margin: '30px 40px 0'
  },
  logo: {
    display: 'block',
    height: '27px'
  },
  title: {
    flex: 1,
    textTransform: 'uppercase',
    textAlign: 'right',
    margin: 'auto 20px'
  }
}

export const useStyles = createUseStyles(style)
